export default function () {
  window.onNuxtReady(() => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = 'https://use.typekit.net/gus4jzq.css'
      document.head.appendChild(link)
  })
}
